import { observer } from 'mobx-react-lite'
import { Flex, Text, Heading, Center } from '@chakra-ui/react'
import { useTranslation,useTranslationWithFallback } from '../utils/hooks'
import { ResponsiveContainer } from '../components'
import DoubleCircleIcon from '../components/DoubleCircleIcon'

export default observer(function Unavailable () {
  const { t } =  useTranslationWithFallback()
  return (
    <Center style={{height: '100vh', backgroundColor: '#f8f8f9'}}>
    <ResponsiveContainer justifyContent={'center'} alignItems={'center'} bg={'white'} p={'32px'} maxWidth='456px'>
      <DoubleCircleIcon
        mb={'10px'}
        icon={'zen-icon_ic_src_zenchef'}
        checkIcon={'zen-icon_ic_warning'}
        checkIconFontSize={'14px'}
        checkIconSize={'17px'}
        checkIconBg={'#DBB704'}
      />
      <Flex flexDirection={'column'} px={'20px'}>
        <Heading
          variant='h4'
          letterSpacing={'0.5px'}
          textAlign={'center'}
          fontSize={'xs'}
          fontWeight={'medium'}
          color={'#2c3037'}
          textTransform='uppercase'>
          {t('commands_widget_unavailable')}
        </Heading>
        <Text textAlign={'center'} fontSize={12} color={'zcf-light-black'}>
        <div
              dangerouslySetInnerHTML={{
                __html: t('commands_widget_unavailable_description')
              }}
            />
        </Text>
      </Flex>
    </ResponsiveContainer>
    </Center>
  )
})
